/** @jsxImportSource @emotion/react */

import ImageNotification from "assets/Desktop/images/homepage/icon-notification.png";
import Container from "components/Desktop/base/Container";
import { useAppSelector } from "hooks/app-hook";
import { selectHomeAnnouncement } from "store/announcement";

import { NotificationCustomStyle } from "./style";

const NotificationCustom = () => {
  const dataAnnouncement = useAppSelector(selectHomeAnnouncement);

  return (
    <section css={NotificationCustomStyle.wrapper}>
      <Container>
        <div css={NotificationCustomStyle.item}>
          <img src={ImageNotification} alt="" />
          <div css={NotificationCustomStyle.text}>
            <span>
              {dataAnnouncement.map((item, index) => (
                <div
                  key={index}
                  className="width-text"
                  dangerouslySetInnerHTML={{
                    __html: `${item.title}`,
                  }}
                />
              ))}
            </span>
          </div>
        </div>
      </Container>
    </section>
  );
};
export default NotificationCustom;
